<template>
  <div>
    <h3 class="title bold align--center margin__b--24">
      {{ t('literal.forgot_password') }}
    </h3>

    <form
      novalidate
      @submit.prevent="handleSubmitForm()"
    >
      <form-notification
        class="margin__b--12"
        :keys="error"
      />

      <fieldset>
        <label
          class="input__label"
          for="forgot_email"
        >
          {{ t('literal.email') }} *
        </label>

        <input-email
          id="forgot_email"
          class="margin__t--6"
          :required="true"
          autocomplete="email"
          v-model="user.email"
          :v="v$.email"
        />
      </fieldset>

      <div class="d-flex justify-content-center margin__t--36">
        <app-save-button
          type="submit"
          class="btn__size--medium"
          :show-icon="false"
          :is-loading="loader"
        >
          {{ t('literal.send') }}
        </app-save-button>
      </div>
    </form>

    <hr class="separator separator__size--full color--dw margin__tb--24">

    <p class="align--center">
      {{ t('literal.have_an_account') }}

      <button
        type="button"
        class="link__color--prim link--naked bold"
        @click="emit('redirectTo', 'login')"
      >
        {{ t('literal.log_in') }}
      </button>
    </p>
  </div>
</template>

<script setup>
import { defineAsyncComponent, onUnmounted, reactive } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { useNotificationStore } from '@/stores/NotificationStore'
import { useI18n } from '@/vendors/i18n'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

import InputEmail from '&/atoms/InputEmail'
import AppSaveButton from '&/molecules/AppSaveButton'
const FormNotification = defineAsyncComponent(() => import('&/molecules/FormNotification'))

const emit = defineEmits(['redirectTo'])

const { t } = useI18n()
const { postSideNotification } = useNotificationStore()
const { postAuthUserPassword, $resetStore } = useAuthenticationStore()
const { loader, error } = storeToRefs(useAuthenticationStore())

const user = reactive({ email: null })

const rules = { email: { required, email } }

const v$ = useVuelidate(rules, user)

const handleSubmitForm = () => {
  v$.value.$validate()

  if (v$.value.$invalid) return

  postAuthUserPassword({ params: user })
    .then(() => {
      postSideNotification({ text: 'literal.the_reset_password_email_has_been_sent', delay: 5000 })

      emit('redirectTo', 'login')
    })
}

onUnmounted(() => $resetStore('error'))
</script>

<style scoped lang="scss">
.title {
  font-size: rem(14px);
}
</style>

